import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * Compact product image carousel used inside catalog cards.
 * Falls back gracefully to a single image if only one is provided.
 */
export function ProductGallery({ images = [], alt = "", className = "" }) {
  const list = Array.isArray(images) ? images.filter(Boolean) : [];
  const [idx, setIdx] = useState(0);

  if (list.length === 0) return null;

  const go = (delta, e) => {
    e?.stopPropagation?.();
    e?.preventDefault?.();
    setIdx((i) => (i + delta + list.length) % list.length);
  };

  return (
    <div className={`relative w-full h-full ${className}`} data-testid="product-gallery">
      <img
        src={list[idx]}
        alt={alt}
        className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
        loading="lazy"
      />
      {list.length > 1 && (
        <>
          <button
            type="button"
            onClick={(e) => go(-1, e)}
            aria-label="Photo précédente"
            className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-black rounded-full w-8 h-8 flex items-center justify-center shadow opacity-0 group-hover:opacity-100 transition-opacity"
            data-testid="gallery-prev"
          >
            <ChevronLeft size={16} />
          </button>
          <button
            type="button"
            onClick={(e) => go(1, e)}
            aria-label="Photo suivante"
            className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-black rounded-full w-8 h-8 flex items-center justify-center shadow opacity-0 group-hover:opacity-100 transition-opacity"
            data-testid="gallery-next"
          >
            <ChevronRight size={16} />
          </button>
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1.5">
            {list.map((_, i) => (
              <button
                key={i}
                type="button"
                onClick={(e) => { e.stopPropagation(); e.preventDefault(); setIdx(i); }}
                aria-label={`Voir photo ${i + 1}`}
                className={`w-1.5 h-1.5 rounded-full transition-all ${i === idx ? "bg-white w-4" : "bg-white/60 hover:bg-white/80"}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
